import { getCountryCode } from '../../helpers/location'
import useCountryCodes from '../../helpers/country-codes'

const removeClass = (selector, className) => {
  const elements = document.querySelectorAll(selector)
  elements.forEach(el => {
    el.classList.remove(className)
  })
}

const checkRegion = () => {
  getCountryCode({
    defaultCountry: 'US',
    onSuccess: (code) => {
      const { europeanCountries } = useCountryCodes()

      if (europeanCountries.includes(code)) {
        removeClass('.eu', 'hide')
      } else {
        removeClass('.not-eu', 'hide')
      }
    }
  }
  )
}

export default checkRegion
